<template>
  <div id="evaluations-panel" class="pt-5 pb-5 is-max-desktop">
    <EvaluationBreadcrumb :links="links" />
    <div v-if="!isLoadingEvaluation">
      <EvaluationHeader :debtor="debtor" />
      <div id="evaluations-details" class="box">
        <b-button
          :disabled="!isUserAllowed()"
          tag="router-link"
          data-cy="new-evaluation"
          :to="{ name: 'evaluation-process', params: { evaluationId: $route.params.evaluationId }}"
          type="is-secondary"
          label="Nueva evaluación"
          class="mb-2 is-pulled-right" />
        <div class="is-clearfix" />
        <EvaluationTable :id-number="debtor.idNumber" />
      </div>
    </div>
    <Spinner v-if="isLoadingEvaluation" />
  </div>
</template>

<script>
import Spinner from '@/ui/components/Spinner.vue';
import EvaluationHeader from '@/ui/components/internal/evaluations/EvaluationHeader.vue';
import EvaluationTable from '@/ui/components/internal/evaluations/EvaluationTable.vue';
import EvaluationBreadcrumb from '@/ui/components/internal/evaluations/EvaluationBreadcrumb.vue';
import { BffEvaluationsClient } from '@/application/services/evaluations/apis/bff-evaluations-client';
import '@/ui/assets/css/custom-components.css';
import { authenticationService } from '@/application/services/api-clients/login-service';
import { evaluationsBackend } from '@/application/api';

export default {
  name: 'EvaluationDetail',
  components: {
    EvaluationBreadcrumb,
    EvaluationTable,
    EvaluationHeader,
    Spinner
  },
  data() {
    return {
      evaluationId: null,
      debtor: {},
      isLoadingEvaluation: true,
      links: [],
      evaluationsClient: new BffEvaluationsClient(evaluationsBackend, authenticationService)
    };
  },
  async mounted() {
    this.evaluationId = this.$route.params.evaluationId;
    this.isUserAllowed();
    await this.fetchEvaluation();
  },
  methods: {
    isUserAllowed() {
      const res = this.$store.state.currentUser.user.allowedUserFeatures?.includes('endpoint.simulator-backend.risk-evaluation/:POST') || this.$store.state.currentUser.user.rol === 'ADMIN';

      return res;
    },
    setlinksForBreadcrumb() {
      this.links.push({
        to: { name: 'evaluation-detail', params: { evaluationId: this.evaluationId } },
        active: true,
        label: this.debtor.fullName
      });
    },
    async fetchEvaluation() {
      try {
        this.debtor = await this.getDebtorData();
      } catch (error) {
        this.$log.error(`Error al obtener información de deudor: ${error.message}`);
      } finally {
        this.isLoadingEvaluation = false;
        this.setlinksForBreadcrumb();
      }
    },
    async getDebtorData() {
      try {
        const responseEvaluation = await this.evaluationsClient.getGeneral(this.$route.params.evaluationId);
        const evaluation = responseEvaluation.data;
        const response = await this.evaluationsClient.getDebtor(evaluation.idNumber);
        return response.data;
      } catch (_error) {
        throw new Error(`Error: ${_error.message}`);
      }
    }
  }
};
</script>
<style scoped>
h2 {
  color: var(--color-nickel);
}
.box {
  border-radius: 10px;
}
a.is-secondary{
  background-color: var(--secondary);
  color: #FFF !important;
  font-weight: 600;
  border-color: transparent;
}
</style>
